/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of importing a Gmail thread
 * @export
 * @interface ImportGmailThreadResponse
 */
export interface ImportGmailThreadResponse {
    /**
     * Whether the import completed
     * @type {boolean}
     * @memberof ImportGmailThreadResponse
     */
    success: boolean;
    /**
     * Number of new messages imported
     * @type {number}
     * @memberof ImportGmailThreadResponse
     */
    imported: number;
    /**
     * Number of messages skipped (already imported)
     * @type {number}
     * @memberof ImportGmailThreadResponse
     */
    skipped: number;
    /**
     * Any errors encountered during import
     * @type {Array<string>}
     * @memberof ImportGmailThreadResponse
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the ImportGmailThreadResponse interface.
 */
export function instanceOfImportGmailThreadResponse(value: object): value is ImportGmailThreadResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('imported' in value) || value['imported'] === undefined) return false;
    if (!('skipped' in value) || value['skipped'] === undefined) return false;
    return true;
}

export function ImportGmailThreadResponseFromJSON(json: any): ImportGmailThreadResponse {
    return ImportGmailThreadResponseFromJSONTyped(json, false);
}

export function ImportGmailThreadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGmailThreadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'imported': json['imported'],
        'skipped': json['skipped'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ImportGmailThreadResponseToJSON(json: any): ImportGmailThreadResponse {
    return ImportGmailThreadResponseToJSONTyped(json, false);
}

export function ImportGmailThreadResponseToJSONTyped(value?: ImportGmailThreadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'imported': value['imported'],
        'skipped': value['skipped'],
        'errors': value['errors'],
    };
}

